import * as THREE from "three";

export function toVector3(point) {
  return new THREE.Vector3(
    Number(point?.x) || 0,
    Number(point?.y) || 0,
    Number(point?.z) || 0
  );
}

export function projectDimensionPoint(a, rawB, mode = "free") {
  if (mode === "x") return new THREE.Vector3(rawB.x, a.y, a.z);
  if (mode === "y") return new THREE.Vector3(a.x, rawB.y, a.z);
  if (mode === "z") return new THREE.Vector3(a.x, a.y, rawB.z);
  return rawB.clone();
}

export function calculateDimensionValue(points = [], mode = "free") {
  if (!Array.isArray(points) || points.length < 2) return null;

  const a = toVector3(points[0]?.world || points[0]);
  const rawB = toVector3(points[1]?.world || points[1]);
  const b = projectDimensionPoint(a, rawB, mode);

  const dx = rawB.x - a.x;
  const dy = rawB.y - a.y;
  const dz = rawB.z - a.z;

  const free = Math.sqrt(dx * dx + dy * dy + dz * dz);
  const axisDistance = b.distanceTo(a);

  return {
    mode,
    value: Number((mode === "free" ? free : axisDistance).toFixed(3)),
    free: Number(free.toFixed(3)),
    dx: Number(dx.toFixed(3)),
    dy: Number(dy.toFixed(3)),
    dz: Number(dz.toFixed(3)),
  };
}